/**
 * Maps an application's lobType (returned from the backend on
 * ApplicationInGroup) to a user-facing product label shown in the Coverages
 * card header, e.g. "{label} Policy:".
 *
 * lobType is an open-ended string from the backend; unknown values fall back
 * to the raw lobType so they remain visible rather than rendering blank.
 */

/* Not used at this moment, will use when E&O actually comes */
export const lobTypeToProductLabel = (lobType: string): string => {
  switch (lobType) {
    case 'GL':
      return 'Commercial General Liability';
    case 'EO':
      return 'Professional Liability';
    default:
      return lobType;
  }
};

/**
 * Abbreviated product label, for places where the full name would crowd the
 * copy — e.g. the edit-policy confirmation heading ("Want to edit your CGL
 * policy?"). Falls back to the raw lobType for the same reason as above.
 */
export const lobTypeToShortProductLabel = (lobType: string): string => {
  switch (lobType) {
    case 'GL':
      return 'CGL';
    case 'EO':
      return 'E&O';
    default:
      return lobType;
  }
};
